import useProjectEntriesCall, { toTimestampLike } from './useProjectEntriesCall'

/**
 * @typedef {object} ResultEntry
 * @property {string} docid - Document-id
 * @property {{toDate: () => Date} | null} Timestamp - Zelfde vorm als een Firestore-Timestamp
 */

/** @returns {ResultEntry} */
const toDoc = (/** @type {{id: string, t: number|null}} */ entry) => ({
    docid: entry.id,
    Timestamp: toTimestampLike(entry.t),
})

/**
 * Id en tijdstip van de outputs van één project, voor de voortgangspagina van de
 * koepel, via de Cloud Function `getProjectResultEntries`. Las tot 2026-11-04 rechtstreeks
 * uit Results, wat alleen werkte omdat iedereen die collectie mocht lezen.
 *
 * @param {string} compagnyId - Het project; '' = nog onbekend
 * @returns {{docs: Array<ResultEntry> | '', error: {code?: string, message?: string} | null, loading: boolean}}
 */
const useProjectResultEntries = (compagnyId) => useProjectEntriesCall(
    'getProjectResultEntries', compagnyId, toDoc, 'useProjectResultEntries'
)

export default useProjectResultEntries
